import axios from 'axios';
import { LocalStorageService } from '../service/LocalStorageService';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(config => {
  const accessToken = LocalStorageService.getItem('accessToken');

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  config.headers['Strict-Transport-Security'] =
    'max-age=31536000; includeSubDomains';
  config.headers['Content-Security-Policy'] = `default-src 'self'`;
  config.headers['X-Frame-Options'] = 'sameorigin';
  config.headers['X-Content-Type-Options'] = 'nosniff';
  config.headers['Referrer-Policy'] = 'no-referrer-when-downgrade';
  config.headers['Permissions-Policy'] = 'microphone=()';

  return config;
});

export { api };